import { Resource } from './resource';

export class JobRecruiter extends Resource {
    user:Object;
    recruiterComment: String;
    jobId :String;
    startDate: String;
    endDate: String;
    expectedOffer: String;
    expectedJoining: String;
    position: Number;
    deleted: Boolean;
    id: String;
}


